
import { ref } from "vue"
import { Toast } from "vant"
import httpUtil from "@/assets/script/utils/http.util"

export default {
  setup() {
    const email = ref("")
    const isValid = ref(true)
    const isCaptcha = ref(true)
    const captcha = ref("")
    const oneMinute = ref(60)

    document.title = "AI Bed"

    const deleteAccount = () => {
      const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      isValid.value =
        email.value.trim().length > 0 && EMAIL_REGEX.test(email.value.trim())
      isCaptcha.value = captcha.value.trim().length > 0
      if (isValid.value && isCaptcha.value) {
        // 删除账号
        httpUtil
          .post(
            "email/deleteAccount",
            { email: email.value.trim(), captcha: captcha.value },
            "form"
          )
          .then((res: any) => {
            if (res.status == 200 && res.data == true) {
              Toast.success("Account deleted successfully")
            } else {
              Toast.fail(res.message)
            }
          })
      }
    }
    const sendCaptcha = () => {
      const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      isValid.value =
        email.value.trim().length > 0 && EMAIL_REGEX.test(email.value.trim())
      if (isValid.value && oneMinute.value == 60) {
        // 发送验证码
        httpUtil
          .post(
            "email/sendCode",
            {
              emailOrPhone: email.value.trim(),
              verificationCodeOperation: "LOGIN"
            },
            "form"
          )
          .then((res: any) => {
            if (res.status == 200 && res.data == true) {
              Toast.success("Captcha sent successfully")
              const timer = setInterval(() => {
                if (oneMinute.value > 0) {
                  oneMinute.value = oneMinute.value - 1
                } else {
                  oneMinute.value = 60
                  clearInterval(timer)
                }
              }, 1000)
            } else {
              Toast.fail(res.message)
            }
          })
      }
    }

    return {
      deleteAccount,
      email,
      captcha,
      sendCaptcha,
      isValid,
      oneMinute,
      isCaptcha
    }
  }
}
